import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ClaimDetailView from '../components/claims/ClaimDetailView';

// /therapist/claims/:id — the shared detail view limited to the therapist's actions
// (attest, fix pointers/modifiers/POS/telehealth, mark ready, notes, status check).
export default function TherapistClaimDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => { if (!localStorage.getItem('token')) navigate('/'); }, [navigate]);
  return <ClaimDetailView claimId={id} role="therapist" backTo="/therapist/claims" />;
}
